(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d5-sticky-product-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('d5-sticky-product-bar')) {
    customElements.define('d5-sticky-product-bar', class extends HTMLElement {
      connectedCallback() {
        this.submit = this.querySelector('[data-d5-sticky-submit]');
        this.price = this.querySelector('[data-d5-sticky-price]');
        this.productInfo = document.querySelector('product-info');
        this.sync = this.sync.bind(this);
        this.updateVisibility = this.updateVisibility.bind(this);
        this.submit.addEventListener('click', () => {
          const mainSubmit = this.productInfo?.querySelector('.product-form__submit');
          if (mainSubmit && !mainSubmit.disabled) mainSubmit.click();
        });
        window.addEventListener('scroll', this.updateVisibility, { passive: true });
        window.addEventListener('resize', this.updateVisibility);
        if (this.productInfo) {
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(this.productInfo, { childList: true, subtree: true, characterData: true, attributes: true });
        }
        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateVisibility);
        window.removeEventListener('resize', this.updateVisibility);
        this.observer?.disconnect();
      }

      sync() {
        const mainSubmit = this.productInfo?.querySelector('.product-form__submit');
        const mainLabel = mainSubmit?.querySelector('span');
        const visiblePrices = Array.from(this.productInfo?.querySelectorAll('[id^="price-"] .price-item') || []).filter((item) => item.offsetParent !== null);
        const currentPrice = visiblePrices[visiblePrices.length - 1];
        if (mainLabel) this.submit.textContent = mainLabel.textContent.trim();
        if (currentPrice) this.price.textContent = currentPrice.textContent.trim();
        this.submit.disabled = !mainSubmit || mainSubmit.disabled;
        this.updateVisibility();
      }

      updateVisibility() {
        const mainSubmit = this.productInfo?.querySelector('.product-form__submit');
        if (!mainSubmit || window.innerWidth > 749) {
          this.hidden = true;
          return;
        }
        this.hidden = mainSubmit.getBoundingClientRect().bottom > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  function initializeD5CatalogPaths() {
    document.querySelectorAll('[data-d5-catalog-paths]').forEach((paths) => {
      if (paths.dataset.d5CatalogPathsBound === 'true') return;
      paths.dataset.d5CatalogPathsBound = 'true';

      const catalog = paths.closest('.d5-catalog-grid');
      const gridContainer = catalog?.querySelector('#ProductGridContainer');
      const applyPath = (path) => {
        catalog?.querySelectorAll('#product-grid > .grid__item[data-d5-practice]').forEach((card) => {
          const matches = path === 'all' || (card.dataset.d5Practice || '').split(' ').includes(path);
          card.classList.toggle('d5-catalog-filter-hidden', !matches);
        });
      };

      paths.addEventListener('click', (event) => {
        const button = event.target.closest('[data-d5-catalog-path]');
        if (!button) return;

        const path = button.dataset.d5CatalogPath;
        paths.querySelectorAll('[data-d5-catalog-path]').forEach((control) => {
          control.setAttribute('aria-pressed', String(control === button));
        });
        paths.dataset.d5CatalogPath = path;
        applyPath(path);
      });

      if (gridContainer) {
        new MutationObserver(() => applyPath(paths.dataset.d5CatalogPath || 'all')).observe(gridContainer, { childList: true });
      }
    });
  }

  initializeD5CatalogPaths();
  document.addEventListener('shopify:section:load', initializeD5CatalogPaths);

  } catch(e) { console.error(e); }
})();
})();
